import solarlunar from 'solarlunar';

// solarlunar ships its functions under `.default` in some bundlers — handle both.
const SL = solarlunar.default || solarlunar;

// Lunar (農曆) -> solar "YYYY-MM-DD". Returns null if the date is invalid.
export function lunarToSolar(year, month, day, isLeap) {
  try {
    const r = SL.lunar2solar(Number(year), Number(month), Number(day), !!isLeap);
    if (!r || r === -1 || !r.cYear) return null;
    return `${r.cYear}-${String(r.cMonth).padStart(2, '0')}-${String(r.cDay).padStart(2, '0')}`;
  } catch {
    return null;
  }
}

// Which month number is the leap month in a lunar year (0 = no leap month).
export function leapMonthOf(year) {
  try { return SL.leapMonth(Number(year)) || 0; } catch { return 0; }
}

// Allowed birth-date range: 1950-01-01 .. today.
export const MIN_BIRTH_DATE = '1950-01-01';
export function todayISO() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

// Solar "YYYY-MM-DD" -> 繁中 lunar label, e.g. 農曆 1990年四月廿一（庚午年）.
export function solarToLunarText(solarDate) {
  if (!solarDate) return '';
  const [y, m, d] = String(solarDate).split('-').map(Number);
  if (!y || !m || !d) return '';
  try {
    const r = SL.solar2lunar(y, m, d);
    if (!r || r === -1 || !r.lYear) return '';
    return `農曆 ${r.lYear}年${r.isLeap ? '閏' : ''}${r.lMonth}月${r.lDay}日（${r.gzYear}年）`;
  } catch {
    return '';
  }
}

// Solar "YYYY-MM-DD" -> "庚午年 · 屬馬" — zodiac sanity hint for lunar input
// (catches the year-end trap where the ID-card year is one greater than the lunar year).
export function ganzhiAnimalOf(solarDate) {
  if (!solarDate) return '';
  const [y, m, d] = String(solarDate).split('-').map(Number);
  if (!y || !m || !d) return '';
  try {
    const r = SL.solar2lunar(y, m, d);
    if (!r || r === -1 || !r.gzYear) return '';
    return `${r.gzYear}年${r.animal ? ` · 屬${r.animal}` : ''}`;
  } catch {
    return '';
  }
}

export const LUNAR_MONTHS = [
  '正月', '二月', '三月', '四月', '五月', '六月',
  '七月', '八月', '九月', '十月', '十一月', '臘月',
]; // index + 1 = month number

export const LUNAR_DAYS = [
  '初一', '初二', '初三', '初四', '初五', '初六', '初七', '初八', '初九', '初十',
  '十一', '十二', '十三', '十四', '十五', '十六', '十七', '十八', '十九', '二十',
  '廿一', '廿二', '廿三', '廿四', '廿五', '廿六', '廿七', '廿八', '廿九', '三十',
]; // index + 1 = day number

// 十二時辰 (each a two-hour block); `time` = representative HH:MM stored as canonical.
export const SHICHEN = [
  { value: '子', label: '子時（23:00–01:00）', time: '23:00' },
  { value: '丑', label: '丑時（01:00–03:00）', time: '01:00' },
  { value: '寅', label: '寅時（03:00–05:00）', time: '03:00' },
  { value: '卯', label: '卯時（05:00–07:00）', time: '05:00' },
  { value: '辰', label: '辰時（07:00–09:00）', time: '07:00' },
  { value: '巳', label: '巳時（09:00–11:00）', time: '09:00' },
  { value: '午', label: '午時（11:00–13:00）', time: '11:00' },
  { value: '未', label: '未時（13:00–15:00）', time: '13:00' },
  { value: '申', label: '申時（15:00–17:00）', time: '15:00' },
  { value: '酉', label: '酉時（17:00–19:00）', time: '17:00' },
  { value: '戌', label: '戌時（19:00–21:00）', time: '19:00' },
  { value: '亥', label: '亥時（21:00–23:00）', time: '21:00' },
];

// Display helpers (fall back to raw fields for requests created before this feature).
export function birthDateText(req) {
  return (req && (req.birth_date_display || req.birth_date)) || '—';
}
export function birthTimeText(req) {
  return (req && (req.birth_time_display || req.birth_time)) || '—';
}
